import { defineStyle } from '@chakra-ui/react';

const baseStyle = defineStyle({
  w: 'full',
  minW: 'unset',
  borderRadius: '0',
  color: 'ourWhite',
  p: '16px',
  fontWeight: '500',
  lineHeight: '100%',
  letterSpacing: '0',
  transition: 'all 0.2s',
});

const variants = {
  black: defineStyle({ fontSize: { mobile: '16px', laptop: '20px' }, h: 'unset', bg: 'ourBlack' }),
  accent: defineStyle({
    fontSize: { mobile: '16px', laptop: '20px' },
    h: 'unset',
    bg: 'orangeAccent',
  }),
};

export const Button = {
  baseStyle,
  variants,
};
